export enum UnitTypeEnum {
    PLANT = "PLANT",
    SUB_PLANT = "SUB PLANT",
    HO ="HO",
    SUB_CONTRACTOR_PLANT = "SUB CONTRACTOR PLANT",
    MANUFACTURING_PLANT="MANUFACTURING PLANT"
}